import * as React from 'react'
import { Page, Document, StyleSheet, PDFViewer } from '@react-pdf/renderer'

const styles = StyleSheet.create({
  body: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 35,
  },
})

interface IPdfHandlerProps {
  title: string
  children: React.ReactNode
}

const PdfHandler: React.FC<IPdfHandlerProps> = ({ children, title }) => {
  const PDF = () => (
    <Document title={title}>
      <Page size="A4" style={styles.body}>
        {children}
      </Page>
    </Document>
  )

  return (
    <PDFViewer style={{ minWidth: '90vh', minHeight: '100vh' }}>
      <PDF />
    </PDFViewer>
  )
}

export default PdfHandler
